$(function() {
    $('.howToUseAccordionArea .howToUseAccordionTitle').click(function() {
      $(this).next('.howToUseAccordionText').slideToggle(400);
      $(this).toggleClass("is-open");
    });
  });

  // カラム時の高さ調整
  $(function() {
    $(".buyWithList h3").matchHeight();
    $(".buyWithList p").matchHeight();
  });

// よくあるご質問
$(function(){
  $(".productFaqHead").on("click", function() {
    $(this).toggleClass("is-open");
    $(this).next().slideToggle();
  });
  $(".productFaqBody dt").on("click", function() {
    $(this).toggleClass("is-open");
    $(this).next().slideToggle();
  });
});